export default __webpack_public_path__ + "static/media/tooltip3D-simple.5e7711cf.png";